import { render, staticRenderFns } from "./LianLianCard.vue?vue&type=template&id=98e94978&"
import script from "./LianLianCard.vue?vue&type=script&lang=js&"
export * from "./LianLianCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports